
import BaseModel from '../../../helpers/basemodel'
import alert from '../../../helpers/alert'
import Api from '../../../helpers/api'
import QueryString from '../../../helpers/query-string'
import moment from 'moment'

/**
 * Const
 *
 */
const api = new Api()
const defaultDate = moment()


/**
 * State
 *
 */
const state = {
  ...BaseModel.state,
}

state.listOptions.month = defaultDate.format(`MM`)
state.listOptions.year = defaultDate.format(`YYYY`)


/**
 * Getters
 *
 */
const getters = {
  ...BaseModel.getters,
}


/**
 * Actions
 *
 */
const actions = {
  ...BaseModel.actions,

  async fetch({ commit, getters }, employee_id) {
    commit(`loading_mode`, 1)

    return api.get(`/employee/${employee_id}/sallary-setting`)
    .then(({ data }) => {
        commit(`loading_mode`, 0)
        commit(`set_list`, data)
        // commit(`update_list_version`)
      })
      .catch(err => {
        commit(`loading_mode`, 0)
        commit(`show_error`, err.message)
        return 0
      })
  },

  async add({ commit, getters }, { eid, data }) {
    commit(`loading_mode`, 1)

    const onsuccess = async (result) => {
      commit(`loading_mode`, 0)

      alert.success(`Data berhasil ditambahkan`)
      return 1
    }

    const onerror = (err) => {
      commit(`loading_mode`, 0)

      if (err.message) alert.danger(err.message)
      return 0
    }

    return api.post(`/employee/${eid}/sallary-setting`, data)
      .then(r => onsuccess(r.data))
      .catch(onerror)
  },

  async setSallary({ commit, getters }, { eid, data }) {
    commit(`loading_mode`, 1)

    const onsuccess = async (result) => {
      commit(`loading_mode`, 0)

      alert.success(`Data berhasil diupdate`)
      return 1
    }

    const onerror = (err) => {
      commit(`loading_mode`, 0)

      if (err.message) alert.danger(err.message)
      return 0
    }

    return api.post(`/employee/${eid}/sallary-setting/${data.id}`, data)
      .then(r => onsuccess(r.data))
      .catch(onerror)
  },

  async remove({ commit, getters }, { eid, data }) {
    commit(`loading_mode`, 1)

    const onsuccess = async (result) => {
      commit(`loading_mode`, 0)

      alert.success(`Data berhasil dihapus`)
      return 1
    }

    const onerror = (err) => {
      commit(`loading_mode`, 0)

      if (err.message) alert.danger(err.message)
      return 0
    }

    return api.delete(`/employee/${eid}/sallary-setting/${data.id}`)
      .then(r => onsuccess(r.data))
      .catch(onerror)
  },
}

/**
 * Mutations
 *
 */
const mutations = {
  ...BaseModel.mutations,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}